import axios from '../util/CustomAxios';
export const RECEIVE_PRODUCT_LIST = 'RECEIVE_PRODUCT_LIST';
export const ADD_ORDER_PRODUCT = 'ADD_ORDER_PRODUCT';
export const ADD_ORDER_PRODUCTS = 'ADD_ORDER_PRODUCTS';
export const DELETE_ORDER_PRODUCT = 'DELETE_ORDER_PRODUCT';
export const SET_DISCOUNT = 'SET_DISCOUNT';
export const SET_CUSTOM_DISCOUNT = 'SET_CUSTOM_DISCOUNT';
export const SET_SETTING_DISCOUNT = 'SET_SETTING_DISCOUNT';
export const SET_QUANTITY = 'SET_QUANTITY';
export const SET_INITIAL_PRODUCT_ORDER_LIST = 'SET_INITIAL_PRODUCT_ORDER_LIST';
export const SET_CUSTOM_DESCRIPTION = 'SET_CUSTOM_DESCRIPTION';
export const SET_PRODUCT_RATE = 'SET_PRODUCT_RATE';
export const SET_AMOUNT = 'SET_AMOUNT';

export function receiveProductList(productList) {
  return {
    type: RECEIVE_PRODUCT_LIST,
    productList: productList,
  };
}

export const getProductList = (state) => (dispatch) => {
  return axios
    .get('/Products')
    .then((response) => {
      dispatch(receiveProductList(response.data));
    })
    .catch(function (error) {
      console.log(error);
    });
};

let nextOrderProductID = 0;
export function addOrderProductWithProductModel(
  product,
  productModel,
  quantity,
  discount,
  isCustomDiscount,
  SOIID,
  serials,
  customDescription,
  amount
) {
  return {
    type: ADD_ORDER_PRODUCT,
    id: nextOrderProductID++,
    product,
    productModel,
    quantity,
    discount,
    isCustomDiscount,
    SOIID,
    serials,
    customDescription,
    amount,
  };
}

export const addOrderProduct =
  (
    product,
    quantity,
    discount,
    isCustomDiscount,
    SOIID,
    serials,
    customDescription,
    amount
  ) =>
  (dispatch) => {
    return axios
      .get('/ProductModel', {
        params: { ModelID: product.ModelId ? product.ModelId : 21 },
      })
      .then((response) => {
        dispatch(
          addOrderProductWithProductModel(
            product,
            response.data[0],
            quantity,
            discount,
            isCustomDiscount,
            SOIID,
            serials,
            customDescription,
            amount
          )
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  };

// 여러 항목을 한 번에 productOrderList에 넣는다.
// 기존 SO/Invoice를 불러올 때 항목을 하나씩 dispatch하면 항목이 추가될 때마다
// 자동 할인 티어가 부분 합계 기준으로 다시 계산되어(50% → 52% → 55% ...)
// SET_DISCOUNT가 여러 번 발생하고, 그 과정에서 저장된 amount가 지워진다.
// 전체 리스트를 한 번에 넣으면 티어 계산이 최종 합계 기준으로 한 번만 일어난다.
export function addOrderProducts(productOrders) {
  return {
    type: ADD_ORDER_PRODUCTS,
    productOrders: productOrders.map((productOrder) => ({
      ...productOrder,
      id: nextOrderProductID++,
    })),
  };
}

// 저장된 SO/Invoice 항목 하나를 productOrder 형태로 만든다 (Product, ProductModel 조회 포함).
async function fetchOrderProduct(item) {
  const productResponse = await axios.get(`/Product/${item.ProductID}`);
  const product = productResponse.data[0];
  const modelResponse = await axios.get('/ProductModel', {
    params: { ModelID: product.ModelId ? product.ModelId : 21 },
  });
  return {
    product,
    productModel: modelResponse.data[0],
    quantity: item.Quantity,
    discount: item.Discount,
    isCustomDiscount:
      item.IsCustomDiscount == null ? false : item.IsCustomDiscount,
    SOIID: item.SOIID,
    serials: item.serials,
    customDescription: item.custom_description,
    amount: item.Amount,
    // 주문 당시 단가. Rate 컬럼 도입 이전 주문은 null이며, 이 경우 화면에서
    // 상품의 현재 정가로 대체된다.
    rate: item.Rate,
  };
}

export function deleteOrderProduct(id) {
  return {
    type: DELETE_ORDER_PRODUCT,
    id,
  };
}

// applyToLines가 false면 전역 자동 할인율만 갱신하고 이미 목록에 있는 항목의
// discount/amount는 건드리지 않는다. 저장된 SO/Invoice를 처음 불러온 직후
// (기준선 잡는 시점)에만 false로 호출한다. 저장 당시 확정된 할인율과 금액을
// 화면을 열었다는 이유만으로 덮어쓰지 않기 위함이다.
export function setDiscount(discount, applyToLines = true) {
  return {
    type: SET_DISCOUNT,
    discount,
    applyToLines,
  };
}

export function setCustomDiscount(id, discount) {
  return {
    type: SET_CUSTOM_DISCOUNT,
    id,
    discount,
  };
}

export function setSettingDiscount(id, discount) {
  return {
    type: SET_SETTING_DISCOUNT,
    id,
    discount,
  };
}

export function setQuantity(id, quantity) {
  return {
    type: SET_QUANTITY,
    id,
    quantity,
  };
}

export function setCustomDescription(id, customDescription) {
  return {
    type: SET_CUSTOM_DESCRIPTION,
    id,
    customDescription,
  };
}

export function setProductRate(id, rate, currency) {
  return {
    type: SET_PRODUCT_RATE,
    id,
    rate,
    currency,
  };
}

export function setProductAmount(id, amount) {
  return {
    type: SET_AMOUNT,
    id,
    amount,
  };
}

export function setInitialProductOrderList() {
  return {
    type: SET_INITIAL_PRODUCT_ORDER_LIST,
  };
}

export const getSalesOrderItems = (SOID) => async (dispatch) => {
  try {
    const response = await axios.get(`/SalesOrder/edit/${SOID}/Items`);
    const productOrders = await Promise.all(
      response.data.map((item) =>
        fetchOrderProduct({ ...item, serials: undefined })
      )
    );
    dispatch(addOrderProducts(productOrders));
  } catch (error) {
    console.log(error);
  }
};

export const getInvoiceItems = (SOID) => async (dispatch) => {
  const response = await axios.get(`/Invoice/new/${SOID}/items`);
  const productOrders = await Promise.all(response.data.map(fetchOrderProduct));
  dispatch(addOrderProducts(productOrders));
};

export const getInvoiceEditItems = (invoice_id) => async (dispatch) => {
  const response = await axios.get(`/Invoice/edit/${invoice_id}/items`);
  const productOrders = await Promise.all(response.data.map(fetchOrderProduct));
  dispatch(addOrderProducts(productOrders));
};

export const getInvoiceAddableItems = (invoice_id) => async (dispatch) => {
  try {
    const response = await axios.get(`/Invoice/addable/${invoice_id}/items`);
    const productOrders = await Promise.all(
      response.data.map(fetchOrderProduct)
    );
    dispatch(addOrderProducts(productOrders));
  } catch (error) {
    console.log(error);
  }
};
